import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import links from 'utils/links';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import BookmarkIcon from '@material-ui/icons/BookmarkBorder';
import InfoIcon from '@material-ui/icons/Info';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ShareIcon from '@material-ui/icons/Share';
import { withStyles } from '@material-ui/core/styles';
import ShareOptions from './ShareOptions';

// import ClearIcon from '@material-ui/icons/Clear';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import BookmarkPopup from './bookmark/Bookmark';


const styles = theme => ({
  cardContainer: {
    height: '100%',
    position: 'relative',
  },
  cardContent: {
    paddingBottom: '60px',
  },
  actions: {
    marginTop: '20px',
    position: 'absolute',
    width: '100%',
    bottom: '0',
    backgroundColor: theme.palette.primary.main,
    height: '40px',
  },
  actionIcon: {
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    margin: '5px',
    marginTop: '-30px',
    boxShadow: '1px 1px grey',
    '&:hover': {
      '@media': {
        backgroundColor: '#391b16',
      },
      '&:focus': {
        backgroundColor: 'grey',
      },
    },
  },
  infoIcon: {
    color: theme.palette.secondary.main,
    fontSize: '0.5em',
  },
  actionButton: {
    position: 'absolute',
    left: -theme.spacing.unit * 3 - 4,
    top: 24,
    paddingLeft: theme.spacing.unit * 5,
    textTransform: 'none',
  },
  media: {
    height: 180,
    position: 'relative',
    width: '100%',
    marginTop: '-10px',
  },
  inline: {
    // display: 'inline',
    fontSize: '0.75rem',
    fontWeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    lineHeight: '16px' /* fallback */,
    maxHeight: '32px' /* fallback */,
    WebkitLineClamp: 1 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
  pushRight: {
    marginLeft: 'auto',
  },
  icon: {
    margin: theme.palette.secondary.main,
    fontSize: 32,
    cursor: 'pointer',
    color: '#aeaeae',
  },
  eventName: {
    // display: 'flex',
    justifyContent: 'space-between',
    fontSize: '1.125rem',
    fontWeight: 'medium',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    maxHeight: '32px',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
  },
  descStyle: {
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
    fontSize: '15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    // lineHeight: '16px' /* fallback */,
    maxHeight: '32px' /* fallback */,
    WebkitLineClamp: 1 /* number of lines to show */,
    WebkitBoxOrient: 'vertical',
  },
});

class ArticleCard extends React.Component {
  state = {
    open: false,
    bookmark: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };
  BookmarkOpen = () => {
    this.setState({ bookmark: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    let {
      classes,
      name,
      location,
      img,
      // call,
      cuisine = [],
      // dishes = [],
      data,
      desc,
      removable,
    } = this.props;
    if (!name) {
      return <span />;
    }
    // dishes = dishes ? dishes : [];
    cuisine = cuisine ? cuisine : [];
    removable = removable ? removable : false;
    data.city = data.city ? data.city : {};
    let eateryLink = links.eatery(data.city.name, data.linkTitle);

    return (
      <Card className={classes.cardContainer}>
        <CardHeader
          title={
            <div className={classes.eventName}>
              <Link to={eateryLink}> {name}</Link>
              {removable
                ? ''
                : // <ClearIcon
                //   className={classes.icon}
                //   onClick={() => this.props.onRemove(data.id)}
                // />
                null}
            </div>
          }
          subheader={
            <Link to={eateryLink}>
              <Fragment>
                <Typography
                  variant="subtitle2"
                  classes={{ root: classes.inline }}
                >
                  {location.locality}
                </Typography>
                {/* <br /> */}
                <Typography
                  variant="subtitle2"
                  classes={{ root: classes.inline }}
                >
                  {cuisine.map((cuis, i) => cuis.name).join(' • ')}
                </Typography>
              </Fragment>
            </Link>
          }
        />
        <Link to={eateryLink}>
          <CardMedia
            className={classNames(classes.media)}
            image={img ? img : '/img/na.png'}
          />
        </Link>
        <CardContent className={classes.cardContent}>
          {/* <Link to={eateryLink}>
            {dishes.length > 0 ? (
              <Typography variant="subtitle1">Must Try Dishes</Typography>
            ) : (
              ''
            )}
            <Typography variant="subtitle2">
              {dishes.map((dish, i) => dish).join(' • ')}
            </Typography>
          </Link> */}
          <i className={classes.descStyle}>{desc}</i>
        </CardContent>
        <CardActions className={classes.actions} disableActionSpacing>
          <IconButton className={classes.infoIcon} aria-label="Information">
            <InfoIcon />
          </IconButton>
          <div className={classes.pushRight}>
            {localStorage.getItem('tsUserInfo') ? (
              <React.Fragment>
                <BookmarkPopup
                  open={this.state.bookmark}
                  data={data}
                  name={name}
                />
                <IconButton
                  className={classes.actionIcon}
                  color="secondary"
                  aria-label="Bookmark"
                  onClick={this.BookmarkOpen}
                >
                  <BookmarkIcon />
                </IconButton>
              </React.Fragment>
            ) : (
                <React.Fragment>
                  <IconButton
                    className={classes.actionIcon}
                    color="secondary"
                    aria-label="Bookmark"
                    onClick={this.handleClickOpen}
                  >
                    <BookmarkIcon />
                  </IconButton>
                  <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      {'Talking Street '}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Please Sign-in or Sign-up to proceed/Bookmark
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={this.handleClose}
                        color="primary"
                        autoFocus
                      >
                        Ok
                    </Button>
                    </DialogActions>
                  </Dialog>
                </React.Fragment>
              )}

            <ShareOptions
              shareUrl={window.location.origin + eateryLink}
              shareTitle={'Talking Street : ' + name}
              shareButton={
                <IconButton className={classes.actionIcon} aria-label="Share">
                  <ShareIcon />
                </IconButton>
              }
            />
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={links.map(location.latitude, location.longitude)}
            >
              <IconButton className={classes.actionIcon} aria-label="Location">
                <LocationOnIcon />
              </IconButton>
            </a>
          </div>
        </CardActions>
      </Card>
    );
  }
}

ArticleCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ArticleCard);
